import { useSyncExternalStore } from 'react';

let settledLaunchGameUid: string | null = null;
let settledSuccessfully = false;
const listeners = new Set<() => void>();

const emitChange = (): void => {
  listeners.forEach((listener) => listener());
};

/** Aggregation query finished (success or error) for this launch game uid. */
export const markAggregationSettledForGame = (
  gameUid: string,
  successful = true,
): void => {
  settledLaunchGameUid = gameUid;
  settledSuccessfully = successful;
  emitChange();
};

export const clearAggregationSettlement = (): void => {
  settledLaunchGameUid = null;
  settledSuccessfully = false;
  emitChange();
};

export const isAggregationSettledForLaunch = (launchGameUid: string): boolean =>
  settledLaunchGameUid === launchGameUid;

export const didAggregationSucceedForLaunch = (
  launchGameUid: string,
): boolean => settledLaunchGameUid === launchGameUid && settledSuccessfully;

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export const useIsAggregationSettledForLaunch = (
  launchGameUid: string | null | undefined,
): boolean => {
  const getSnapshot = () =>
    Boolean(launchGameUid && isAggregationSettledForLaunch(launchGameUid));

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};

export const useDidAggregationSucceedForLaunch = (
  launchGameUid: string | null | undefined,
): boolean => {
  const getSnapshot = () =>
    Boolean(launchGameUid && didAggregationSucceedForLaunch(launchGameUid));

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};

/** @internal test helper */
export const resetAggregationSettlementForTests = (): void => {
  settledLaunchGameUid = null;
  settledSuccessfully = false;
  listeners.clear();
};
